import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { AutomotiveIndustryPage } from "@/components/site/AutomotiveIndustryPage";
import { AUTOMOTIVE_META_DESCRIPTION } from "@/content/meta/AutomotiveIndustryPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/industries/automotive")({
  head: () => ({
    meta: [
      { title: "Automotive Media Monitoring & Analysis | Perceptica" },
      { name: "description", content: AUTOMOTIVE_META_DESCRIPTION },
      { property: "og:title", content: "Automotive Media Monitoring & Analysis | Perceptica" },
      { property: "og:description", content: AUTOMOTIVE_META_DESCRIPTION },
      { name: "twitter:title", content: "Automotive Media Monitoring & Analysis | Perceptica" },
      { name: "twitter:description", content: AUTOMOTIVE_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://perceptica.com/industries/automotive" },
      ...ogImageMeta("en", "/industries/automotive"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/industries/automotive" }),
  }),
  component: AutomotiveIndustryPage,
});
